
export const STATS_RANKING = "STATS_RANKING"
export var AllRanking = (state = [], action) => {
    if (action.type === STATS_RANKING) {
      return action.payload;
    }
    return state;
};